import styled from 'styled-components';
import mediaQuery from 'styles/mediaQuery';
import theme from 'styles/theme';

export const ChannelsTableWrapper = styled.section`
  margin-bottom: 46px;

  h2 {
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 20px;
  }

  th.column-header-name {
    width: 320px;
    text-align: left;

    ${mediaQuery.sm} {
      width: 265px;
    }
  }

  th.column-header-actions {
    text-align: right;
  }

  th.column-header-integrationStats_connectedAccounts,
  th.column-header-integrationStats_connectedProperties,
  th.column-header-Rate {
    text-align: center;
  }

  tbody tr td {
    text-align: center;
    vertical-align: middle;
  }

  tbody tr td.body-cell-name {
    text-align: left;
  }

  tbody tr td.body-cell-actions {
    text-align: right;
  }

  .toggle-switch.small {
    left: 0px;
  }

  thead > tr > th.column-header.column-header-actions {
    width: auto;

    ${mediaQuery.sm} {
      width: 130px;
    }
  }

  .connect-via-partner-button {
    margin-right: 10px;

    ${mediaQuery.sm} {
      margin: 15px;
      white-space: break-spaces;
    }
  }

  tbody tr:hover {
    cursor: auto;
  }

  tbody .clickable-channel-row:hover {
    cursor: pointer;
    background-color: ${theme.colors.bgHover};

    p {
      text-decoration: underline;
    }
  }
`;
